import { html } from '../lib/html.js';
import { CATEGORY } from '../services/vehicles.js';

/**
 * Cabeçalho do veículo, igual para o dono e para a oficina:
 * placa no estilo Mercosul + selo de status, nome em destaque e a linha marca · ano · cor.
 * plateAction: tocar na placa dispara esse data-action (ex.: abrir os dados do veículo).
 * compact: menos espaço abaixo (tela do veículo do dono, que tem abas logo depois).
 * category: linha do veículo (selo "Linha pesada · Caminhão"); sem placa (máquina), mostra o número de série.
 * @param {{ plate?: string | null, serial?: string | null, category?: string, title: string, subtitle?: string, status?: any, editable?: boolean, extra?: any, plateAction?: string, compact?: boolean }} o
 */
export function vehicleHero({ plate, serial = null, category = '', title, subtitle = '', status = '', editable = false, extra = '', plateAction = '', compact = false }) {
  const badge = plate ? plateBadge(plate) : serial ? serialBadge(serial) : '';
  const what = plate ? `Placa ${plate}` : `Número de série ${serial ?? ''}`;
  const cat = CATEGORY[category];
  return html`
    <section class="hero ${compact ? 'compact' : ''}">
      <div class="hero-top">
        ${cat && category !== 'LIGHT' ? catTag(category, `${cat.label} · ${cat.kind}`) : status}
        ${badge
          ? plateAction
            ? html`<button type="button" class="badge-btn tappable" data-action="${plateAction}" aria-label="${what}: ver dados do veículo">${badge}</button>`
            : badge
          : ''}
      </div>
      ${cat && category !== 'LIGHT' && status ? html`<div class="hero-status">${status}</div>` : ''}
      <div class="hero-title">
        <h1>${title}</h1>
        ${editable
          ? html`<button type="button" class="icon-btn" data-action="nickname" aria-label="Editar apelido"><ion-icon name="create-outline"></ion-icon></button>`
          : ''}
      </div>
      ${subtitle ? html`<p class="hero-sub">${subtitle}</p>` : ''}
      ${extra}
    </section>`;
}

/** "FORD FIESTA · 2014 · PRATA" */
export const vehicleLine = (v) => [[v.brand, v.model].filter(Boolean).join(' '), v.modelYear, v.color].filter(Boolean).join(' · ');

/** Placa no padrão Mercosul (sempre clara, também no escuro). */
export const plateBadge = (plate) => html`<span class="plate-badge" aria-label="Placa ${plate}"><span class="plate-strip">BRASIL</span><span class="plate-num">${plate}</span></span>`;

/** Número de série (máquina sem placa). */
export const serialBadge = (serial) => html`<span class="serial-badge" aria-label="Número de série ${serial}"><span class="serial-top">Nº DE SÉRIE</span><span class="serial-num">${serial}</span></span>`;

/** Ícone da linha do veículo num quadrado colorido. size: '' | 'sm' | 'lg' */
export const catIcon = (category = 'LIGHT', size = '') => {
  const c = CATEGORY[category] ?? CATEGORY.LIGHT;
  return html`<span class="cat-ic ${size} cat-${c.key}" title="${c.label}"><ion-icon name="${c.icon}" aria-hidden="true"></ion-icon></span>`;
};

/** Selo da linha: ícone + texto ("Linha pesada · Caminhão"). */
export const catTag = (category = 'LIGHT', text = '') => {
  const c = CATEGORY[category] ?? CATEGORY.LIGHT;
  return html`<span class="cat-tag cat-${c.key}"><ion-icon name="${c.icon}" aria-hidden="true"></ion-icon>${text || c.label}</span>`;
};
